import React, { Component } from 'react'
import { withStyles } from '@material-ui/core/styles';
import { connect } from "react-redux"
import { Avatar, Chip, CircularProgress } from '@material-ui/core';
import ErrorIcon from '@material-ui/icons/Error';
import { deleteStatus } from '../Redux/actions';

const styles = theme => ({
    // root: {
    //     backgroundColor: '#ED7D31',
    //     position: 'absolute',
    //     height: '100%',
    //     width: '100%',
    // },
    // centeredContainer: {
    //     // backgroundColor: 'red',    
    //     marginTop: '50vh',
    //     transform: 'translate(0, -50%)',
    //     textAlign: 'center'
    // },
    // titleContainer: {
    //     textAlign: 'center',
    //     color: 'white'
    // },
    // numpadTable: {
    //     display: 'inline-block',
    //     marginTop: '20px'
    // },
    // circleContainer: {
    //     marginTop: '20px',
    //     textAlign: 'center',
    // },
});

class StatusIndicator extends Component {

    handleDelete = id => {
        this.props.dispatch(deleteStatus({
            id
        }))
    }

    render() {

        let component = ''
        if(this.props.status_list.length){
            var element = this.props.status_list[0]

            switch (element.type) {
                case 'indefinite':
                    component = <Chip avatar={<Avatar><CircularProgress size={20} color="primary" /></Avatar>} label={element.text} />
                    break;
                case 'persistent':
                    component = <Chip avatar={<Avatar><ErrorIcon/></Avatar>} label={element.text} onDelete={() => this.handleDelete(element.id)}/>
                    break;
                
                default:
                    break;
            }
        }

        return (
            component
        )
    }
}

const mapStateToProps = (state) => {
    return {
        status_list: state.app.global.status_list,
    }
};

export default connect(mapStateToProps, null)(withStyles(styles)(StatusIndicator));